<template>
  <section>
    <v-card
      elevation="1"
      color="#FFF"
    >
      <v-card-title>
        <p class="process-header">
          Review Details
        </p>
      </v-card-title>
      <v-card-text>
        <div>
          <p class="title-text-style">
            Project: <font class="value-text-style">
              {{ selectedContractDetails.details.project.name }}
            </font>
          </p>
          <p class="title-text-style">
            Check-in Gate: <font class="value-text-style">
              {{ locationName.name }}
            </font>
          </p>
          <p class="title-text-style">
            Contract: <font class="value-text-style">
              {{ selectedContractDetails.details.name }}
            </font>
          </p>
          <p class="title-text-style">
            Description: <font
              v-if="selectedContractDetails.details.description !== null"
              class="value-text-style"
            >
              {{ selectedContractDetails.details.description }}
            </font>
            <font
              v-else
              class="value-text-style"
            >
              N/A
            </font>
          </p>
          <p class="title-text-style">
            Progress : <font
              v-if="selectedContractDetails.details.contract_progress !== null"
              class="value-text-style"
              :color="getProgressColor(selectedContractDetails.details.contract_progress)"
            >
              {{ selectedContractDetails.details.contract_progress }}%
              <v-icon
                large
                :color="getProgressColor(selectedContractDetails.details.contract_progress)"
              >
                mdi-trending-up
              </v-icon>
            </font>
            <font
              v-else
              class="value-text-style"
            >
              N/A
            </font>
          </p>
        </div>
      </v-card-text>

      <centre-spinner
        :loading="loading"
      />
    </v-card>
    <v-btn
      color="#000"
      class="mt-5 btn-style"
      elevation="0"
      @click="checkIn()"
    >
      Check-in
    </v-btn>
    <v-btn
      light
      color="#E6E6E6"
      class="mt-3 btn-style"
      elevation="0"
      @click="cancel()"
    >
      Cancel
    </v-btn>
  </section>
</template>

  <script>
  import spinner from 'src/views/components/SpinnerCentre';
  import Constants from 'src/constants';
  import moment from 'moment';

  export default {
    name: 'ReviewContractDetails',
    components: {
      'centre-spinner': spinner,
    },
    data: () => ({
      loading: false,
      checkInType: 'contractor',
    }),
    computed: {
      selectedContractDetails () {
        return this.$store.getters['swiftuser/getSelectedContractDetails'];
      },
      selectedAnswers () {
        return this.$store.getters['questions/getUserSelectedAnswers'];
      },
      checkInId () {
        return this.$store.getters['swiftuser/getCheckInId'];
      },
      locationName () {
        return this.$store.getters['swiftuser/getLocationName'];
      },
      checkInMethodType () {
        return this.$store.getters['swiftuser/getCheckInMethodType'];
      },
      selectedOrganization () {
        return this.$store.getters['organization/getSelectedOrganization'];
      },
    },
    methods: {
      checkIn () {
        this.loading = true;
        const siteId = this.$route.params.siteId;
        this.$store.dispatch('swiftuser/checkInUser', {
          orgExtId: this.selectedOrganization.organization.external_id,
          details: {
          checkin_time: moment.utc().format(),
          location_id: siteId,
          type: 'contractor',
          checkin_method_type: this.checkInMethodType,
          },
        }).then(response => {
          this.completeCheckInProcess();
        }).catch(errors => {
          this.loading = false;
        });
      },
      async completeCheckInProcess () {
        const selectedAnswers = [];
        selectedAnswers.push({
          answers: this.selectedAnswers,
        });
        await this.$store.dispatch('questions/sendUserSelectedAnswers', {
          answers: selectedAnswers[0],
          checkInId: this.checkInId.id,
        }).then(response => {
          this.sendContractDetails();
        }).catch(() => {
          this.loading = false;
        });
      },
      async sendContractDetails () {
          await this.$store.dispatch('swiftuser/sendContractDetails', {
            details: {
              contract_id: this.selectedContractDetails.details.id,
            },
            checkInId: this.checkInId.id,
          }).then(response => {
            this.loading = false;
            this.$store.dispatch('alert/onAlert', {
              message: 'Check-in completed successfully.',
              type: Constants.ALERT_TYPE_SUCCESS,
            });
            const checkInId = this.checkInId.id;
            localStorage.setItem('checkIn', checkInId);
            this.$emit('checkin-completed');
          }).catch(() => {
            this.loading = false;
          });
      },
      cancel () {
        this.loading = true;
        localStorage.removeItem('siteId');
        localStorage.removeItem('scannedTime');
        setTimeout(() => {
          this.$router.push({ name: 'CheckIn' });
        }, 1000);
      },
      getProgressColor (val) {
        if (val === 0) {
          return '#C62828';
        } else {
          return '#2E7D32';
        }
      },
    },
  };
  </script>
  <style scoped>
  #title-text{
    margin-bottom:1px;
  }
  </style>
